import { render, staticRenderFns } from "./Chamber.vue?vue&type=template&id=061ca4bc&"
import script from "./Chamber.vue?vue&type=script&lang=ts&"
export * from "./Chamber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports